import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles, Typography } from '@material-ui/core';
import { z } from 'zod';
import Form from '../../Common/Form';
import ExpectationsFields from './ExpectationsFields';

const validationSchema = (category = '') => {
  return z
    .object({
      lse_dte_60: z
        .number()
        .positive('This has to be greater than 0')
        .nullable()
        .optional(),
      lse_dte_30: z
        .number()
        .positive('This has to be greater than 0')
        .nullable()
        .optional(),
      lse_dte_15: z
        .number()
        .positive('This has to be greater than 0')
        .nullable()
        .optional(),
      lse_dte_7: z
        .number()
        .positive('This has to be greater than 0')
        .nullable()
        .optional(),
      lse_dte_4: z
        .number()
        .positive('This has to be greater than 0')
        .nullable()
        .optional(),
      lse_sellout_dte_target: z
        .number()
        .nullable()
        .optional(),
      lse_sellout_dte: z
        .number()
        .nullable()
        .optional(),
    })
    .superRefine((data, context) => {
      const notHasDTE60Target = data.lse_dte_60 === null || data.lse_dte_60 === undefined;
      const notHasDTE30Target = data.lse_dte_30 === null || data.lse_dte_30 === undefined;
      const notHasDTE15Target = data.lse_dte_15 === null || data.lse_dte_15 === undefined;
      const notHasDTE7Target = data.lse_dte_7 === null || data.lse_dte_7 === undefined;
      const notHasDTE4Target = data.lse_dte_4 === null || data.lse_dte_4 === undefined;
      const notHasSODTETarget = data.lse_sellout_dte_target === null || data.lse_sellout_dte_target === undefined;
      const notHasSelloutDTE = data.lse_sellout_dte === null || data.lse_sellout_dte === undefined;

      let maxValue = null;
      const wrongValues = [];

      Object.keys(data).forEach(key => {
        if (key.includes('dte') && key !== 'lse_sellout_dte') {
          const value = data[key];
          if (typeof value === 'number') {
            if (maxValue === null) {
              maxValue = value;
            } else if (value > maxValue) {
              wrongValues.push({
                path: [`${key}`],
                message: `${key} wrong value`,
                fatal: true,
                code: z.ZodIssueCode.custom,
              });
            } else {
              maxValue = value;
            }
          }
        }
      });

      wrongValues.forEach(issue => context.addIssue(issue));

      if (category === 'Sports') {
        if (notHasDTE30Target && notHasDTE15Target && notHasDTE4Target && notHasSODTETarget && notHasSelloutDTE) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['lse_dte_30'],
            message: 'Please add value for the DTE 30 Target field.',
            fatal: true,
          });
        }
        if (!notHasDTE30Target || !notHasDTE15Target || !notHasDTE4Target || !notHasSODTETarget || !notHasSelloutDTE) {
          if (notHasDTE30Target) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_dte_30'],
              message: 'Please add value for the DTE 30 Target field.',
              fatal: true,
            });
          } else if (notHasDTE15Target) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_dte_15'],
              message: 'Please add value for the DTE 15 Target field.',
              fatal: true,
            });
          } else if (notHasDTE4Target) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_dte_4'],
              message: 'Please add value for the DTE 4 Target field.',
              fatal: true,
            });
          } else if (notHasSODTETarget) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_sellout_dte_target'],
              message: 'Please add value for the S/O DTE Target field.',
              fatal: true,
            });
          } else if (notHasSelloutDTE) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_sellout_dte'],
              message: 'Please add value for the Sellout DTE field.',
              fatal: true,
            });
          }
        }
      } else {
        if (notHasDTE60Target && notHasDTE30Target && notHasDTE7Target && notHasSODTETarget && notHasSelloutDTE) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['lse_dte_60'],
            message: 'Please add value for the DTE 60 Target field.',
            fatal: true,
          });
        }
        /* eslint-disable no-lonely-if */
        if (!notHasDTE60Target || !notHasDTE30Target || !notHasDTE7Target || !notHasSODTETarget || !notHasSelloutDTE) {
          if (notHasDTE60Target) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_dte_60'],
              message: 'Please add value for the DTE 60 Target field.',
              fatal: true,
            });
          } else if (notHasDTE30Target) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_dte_30'],
              message: 'Please add value for the DTE 30 Target field.',
              fatal: true,
            });
          } else if (notHasDTE7Target) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_dte_7'],
              message: 'Please add value for the DTE 7 Target field.',
              fatal: true,
            });
          } else if (notHasSODTETarget) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['lse_sellout_dte_target'],
              message: 'Please add value for the S/O DTE Target field.',
              fatal: true,
            });
          } else if (notHasSelloutDTE) {
            context.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['hasSellout_DTE'],
              message: 'Please add value for the Sellout DTE field.',
              fatal: true,
            });
          }
        }
        /* eslint-enable no-lonely-if */
      }
    });
};

const DEFAULT_FORM_VALUES = {};

const useStyles = makeStyles(theme => ({
  label: {
    marginBottom: theme.spacing(2),
    fontSize: '14px',
  },
}));

const propTypes = {
  automationData: PropTypes.shape({
    line_segment_expectations: PropTypes.object,
  }),
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  eventMeta: PropTypes.object,
};
const defaultProps = {
  automationData: null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  onReset: undefined,
  eventMeta: undefined,
};

function ExpectationsForm({ automationData, isError, isLoading, isSuccess, onSubmit, onReset, eventMeta }) {
  const classes = useStyles();

  // Memoize the values to prevent the form from resetting during re-renders.
  const initialValues = useMemo(() => {
    if (!automationData) {
      return DEFAULT_FORM_VALUES;
    }

    // eslint-disable-next-line camelcase
    const { line_segment_expectations } = automationData;
    const initialObject = {};
    // eslint-disable-next-line camelcase
    if (line_segment_expectations && Object.keys(line_segment_expectations).length > 0) {
      Object.keys(line_segment_expectations).forEach(key => {
        initialObject[key] = line_segment_expectations[key];
      });
    }
    return initialObject;
  }, [automationData]);

  return (
    <Form
      initialValues={initialValues}
      isError={isError}
      isLoading={isLoading}
      isSuccess={isSuccess}
      validationSchema={validationSchema(eventMeta.category)}
      values={initialValues}
      onSubmit={onSubmit}
      onReset={onReset}
      expectationsForm
    >
      {({ control, formState: { errors, isValid, isLoading: loading, isDirty }, trigger, watch }) => (
        <>
          <Typography classes={{ root: classes.label }} style={{ marginBottom: '-10px' }}>
            Set line segment in order. Each target should be smaller than the next (Ex: 1000, 500, 400, 300)
          </Typography>

          <ExpectationsFields
            formMethods={{ control, errors, trigger, watch, isValid, loading }}
            eventMeta={eventMeta}
            initialValues={initialValues}
            isSuccess={isSuccess}
            isDirty={isDirty}
          />
        </>
      )}
    </Form>
  );
}

ExpectationsForm.propTypes = propTypes;
ExpectationsForm.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    eventMeta: state.pricing.eventMeta,
  };
}

export default connect(mapStateToProps)(ExpectationsForm);
